import { Stack, TableCell, Typography } from '@mui/material';
import { Badge, dateTime, ToAuditButton } from '@shared';
import { RouteEnum } from 'App';
import { IncompleteAuditsUI } from './IncompleteAudits.types';
import { Stars } from '@mui/icons-material';

export function IncompleteAuditsTableCells(props: IncompleteAuditsUI['compositeAudits'][number]) {
  const { uuid, anomalyCount, auditor, auditUuid, partner, specialPartner, ...rest } = props;
  const entries = Object.entries(rest);
  const timeTableCells = entries.map(([keyName, value]) => {
    return (
      <TableCell key={keyName}>
        <Typography component='time' variant='tableCell'>
          {dateTime(value, keyName)}
        </Typography>
      </TableCell>
    );
  });
  return (
    <>
      {timeTableCells[0]}
      <TableCell key={'auditor'}>
        <Typography variant='tableCell'>{auditor}</Typography>
      </TableCell>
      <TableCell key={'partner'}>
        <Stack direction='row' alignItems='center' justifyContent='space-between'>
          <Typography variant='tableCell'>{partner}</Typography>
          {specialPartner && <Badge title='Special partner' icon={<Stars color='primary' />} />}
        </Stack>
      </TableCell>
      {timeTableCells[1]}
      {timeTableCells[2]}
      <TableCell key={'anomalies'}>
        <Typography variant='tableCell'>{anomalyCount}</Typography>
      </TableCell>
      <TableCell>
        <ToAuditButton
          uuid={uuid}
          secondUuid={auditUuid}
          title={'Audit Page'}
          route={RouteEnum.Review}
          navigate
        />
      </TableCell>
    </>
  );
}
